<template>
  <div v-if="facebookPostLink" class="text-xs-center small my-4" style="font-size: small">
    {{ $t('This message was reply automatically.') }}
    <a :href="facebookPostLink" target="_blank">
      {{ $t('Go to post') }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    facebookPostLink() {
      if (this.value.comment_id) {
        return `https://www.facebook.com/${this.value.comment_id}`
      } else {
        const postid = this.value.postid ? this.value.postid.split('_') : null
        if (postid && postid.length > 1) {
          return `https://www.facebook.com/${postid[0]}/posts/${postid[1]}`
        } else return null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatFacebookPostLink.vue